import { isProbablyIpad } from "./orientationLock";

// iPadOS can report a Macintosh UA; pointer type also changes with a trackpad.
const isInstalled = (targetWindow) => targetWindow.navigator?.standalone === true ||
  Boolean(targetWindow.matchMedia && (
    targetWindow.matchMedia("(display-mode: standalone)").matches ||
    targetWindow.matchMedia("(display-mode: fullscreen)").matches
  ));

export const isIpadPwa = (targetWindow = window) => isProbablyIpad(targetWindow) && isInstalled(targetWindow);

export const isIphonePwa = (targetWindow = window) =>
  /iPhone|iPod/i.test(targetWindow.navigator?.userAgent || "") && isInstalled(targetWindow);

// iOS only rereads an installed app's statusbar color with a new document (see themeContext.js).
export const statusbarNeedsNewDocument = (targetWindow = window) =>
  isIpadPwa(targetWindow) || isIphonePwa(targetWindow);

export const reloadDocument = (targetWindow = window) => targetWindow.location.reload();

// In the light theme the login's statusbar is green and the app's is white, so on an
// installed iPad or iPhone entering the app needs a new document (see themeContext.js).
export const loginChangesStatusbar = (targetWindow = window) => {
  const root = targetWindow.document.documentElement;
  return statusbarNeedsNewDocument(targetWindow) && root.classList.contains("auth-page") && root.getAttribute("data-theme") === "light";
};
